import { PageHeroProps } from "../../interface/PageHeroProps";
import { Box, makeStyles, Typography } from "@material-ui/core";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { useHistory } from "react-router";
import { Link as RouterLink } from "react-router-dom";
import { getCurrentUser } from "../../services/authService";
import { useAppSelector } from "../../hooks";

const useStyles = makeStyles({
  backArrow: {
    color: "black",
    marginBottom: 20,
    display: "block",
    cursor: "pointer",
  },
  title: {
    marginBottom: "10px",
  },
  // Header action goes full width on mobile (matches useWindowSize isMobile <= 991).
  action: {
    "@media (max-width:991px)": {
      width: "100%",
    },
  },
});

const PageHero = ({ title, subtitle, showBackButton, action }: PageHeroProps) => {
  const classes = useStyles();
  const history = useHistory();
  const user = useAppSelector(getCurrentUser);

  const goBack = () => {
    history.goBack();
  };

  return (
    <Box
      sx={{
        marginY: 2,
      }}
    >
      {showBackButton && user !== undefined && (
        <div onClick={goBack} className={classes.backArrow}>
          <ArrowBackIcon />
        </div>
      )}
      {showBackButton && user === undefined && (
        <RouterLink to="/" className={classes.backArrow}>
          <ArrowBackIcon />
        </RouterLink>
      )}
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        flexWrap="wrap"
        style={{ gap: 16 }}
      >
        <Box>
          <Typography variant="h3" className={classes.title}>
            {title}
          </Typography>
          <Typography variant="body1">{subtitle}</Typography>
        </Box>
        {action && <Box className={classes.action}>{action}</Box>}
      </Box>
    </Box>
  );
};

export default PageHero;
